module.exports = __webpack_public_path__ + "static/media/5.22c2277a.jpg";